(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.DmsThemeParagraphImageSlider = {
    attach: function (context, settings) {
      $(once('slick', '.paragraph--type--image-slider .field--name-field-images')).on('init', function(e, slick) {
        slick.$slider
          .find(".slick-cloned").children(".lightbox")
          .removeAttr("data-fancybox")
          .attr("data-trigger", slick.$slides.attr("data-fancybox"))
          .each(function() {
            var $slide = $(this),
              clonedIndex = parseInt($slide.attr("data-slick-index")),
              originalIndex =
                clonedIndex < 0
                  ? clonedIndex + slick.$slides.length
                  : clonedIndex - slick.$slides.length;
            $slide.attr("data-index", originalIndex);
          });
      }).each(function(_, $el) {
        $($el).slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true,
          prevArrow: '<div class="slick-prev"></div>',
          nextArrow: '<div class="slick-next"></div>',
          lazyLoad: 'progressive',
          appendDots: $($el).parent()
        });
      });
    }
  };

})(jQuery, Drupal);
